import { Injectable } from '@angular/core';
import { Geolocation } from '@capacitor/geolocation';
import { DeviceNotificationService } from '@ridango/components';

@Injectable({
    providedIn: 'root'
})
export class RequestPermissionService {
    constructor(private readonly deviceNotificationService: DeviceNotificationService) {}

    public async requestPermissionLogin() {
        await this.requestGeolocation();
        await this.deviceNotificationService.checkNotificationSetting();
    }

    public requestPermissionNotification() {
        this.deviceNotificationService.initialize();
    }

    async requestGeolocation() {
        try {
            const permissionStatus = await Geolocation.checkPermissions();

            if (permissionStatus.location === 'prompt') {
                await Geolocation.requestPermissions();
            }

            if (permissionStatus.location === 'denied') {
                throw new Error('User denied permissions!');
            }
        } catch (e) {
            console.log(e);
        }
    }
}
